import { Table } from '@mantine/core';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router';
import ErrorMessage from '../../components/ErrorMessage';
import ProfileEventElements from '../../components/Profiles/ProfileEventElements';
import Spinner from '../../components/Spinner';
import useFetch from '../../helpers/useFetch';

const ProfileEvents = ({ events, eventTypes, showProfileLink = false }) => {
  const fetch = useFetch();
  const [pages, setPages] = useState();
  const [campaigns, setCampaigns] = useState();
  const [emails, setEmails] = useState();
  const [textMessages, setTextMessages] = useState();
  const [viberMessages, setViberMessages] = useState();
  const [pushNotifications, setPushNotifications] = useState();
  const [whatsappMessages, setWhatsappMessages] = useState();
  const [error, setError] = useState();
  const { accountId, domainId } = useParams();

  useEffect(() => {
    fetch(`/api/admin/accounts/${accountId}/domains/${domainId}/pages`)
      .then(({ pages }) => setPages(pages))
      .catch(setError);

    fetch(`/api/admin/accounts/${accountId}/domains/${domainId}/campaigns`)
      .then(({ campaigns }) => setCampaigns(campaigns))
      .catch(setError);

    fetch(`/api/admin/accounts/${accountId}/domains/${domainId}/emails`)
      .then(({ emails }) => setEmails(emails))
      .catch(setError);

    fetch(`/api/admin/accounts/${accountId}/domains/${domainId}/textMessages`)
      .then(({ textMessages }) => setTextMessages(textMessages))
      .catch(setError);

    fetch(`/api/admin/accounts/${accountId}/domains/${domainId}/viberMessages`)
      .then(({ viberMessages }) => setViberMessages(viberMessages))
      .catch(setError);

    fetch(`/api/admin/accounts/${accountId}/domains/${domainId}/pushNotifications`)
      .then(({ pushNotifications }) => setPushNotifications(pushNotifications))
      .catch(setError);

    fetch(`/api/admin/accounts/${accountId}/domains/${domainId}/whatsappMessages`)
      .then(({ whatsappMessages }) => setWhatsappMessages(whatsappMessages))
      .catch(setError);
  }, [accountId, domainId, fetch]);

  if (error) {
    return <ErrorMessage message={error.message} />;
  }

  if (
    !events ||
    !pages ||
    !campaigns ||
    !emails ||
    !textMessages ||
    !viberMessages ||
    !pushNotifications ||
    !whatsappMessages
  ) {
    return <Spinner />;
  }

  return (
    <Table striped withTableBorder highlightOnHover mb="md">
      <Table.Thead>
        <Table.Tr>
          {showProfileLink && <Table.Th>Profile</Table.Th>}
          <Table.Th>Event Type</Table.Th>
          <Table.Th>Time</Table.Th>
          <Table.Th>Details</Table.Th>
          <Table.Th>City</Table.Th>
          <Table.Th>Country</Table.Th>
          <Table.Th>User Agent</Table.Th>
          <Table.Th>Raw Data</Table.Th>
        </Table.Tr>
      </Table.Thead>
      <Table.Tbody>
        <ProfileEventElements
          events={events}
          pages={pages}
          campaigns={campaigns}
          emails={emails}
          textMessages={textMessages}
          viberMessages={viberMessages}
          pushNotifications={pushNotifications}
          whatsappMessages={whatsappMessages}
          showProfileLink={showProfileLink}
          eventTypes={eventTypes}
        />
      </Table.Tbody>
    </Table>
  );
};

export default ProfileEvents;
